import { render, staticRenderFns } from "./table-confirm-delete-keyword.html?vue&type=template&id=c6bbedda&scoped=true&"
import script from "./table-confirm-delete-keyword.js?vue&type=script&lang=js&"
export * from "./table-confirm-delete-keyword.js?vue&type=script&lang=js&"
import style0 from "./table-confirm-delete-keyword.scss?vue&type=style&index=0&id=c6bbedda&prod&scoped=true&lang=scss&"
import style1 from "./table-confirm-delete-keyword-global.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bbedda",
  null
  
)

export default component.exports